export const sidebarContractorOptionsEnum = {
    'search-employe': 'employees',
    'add-new-employe': 'employees',
    'employee-contract-detail': 'employees',
    'create-employee': 'employees',
    'update-employee': 'employees',
    'employee-upload-documents': 'employees',
    'search-vehicle': 'vehicles',
    'addvehical': 'vehicles',
    'vehicle-contract-detail': 'vehicles',
    'upload-vehicle-documents': 'vehicles',
    'vehicle-detail': 'vehicles',
    'update-vehicle': 'vehicles',
    'contracts': 'contractors',
    'user-contract-detail': 'contractors',
    'announcements': 'announcements',
    'profile': 'profile',
};
